import React, {useEffect} from 'react'
import {renderIconSource, renderStatut} from '../../../../../components/renders'
import TempsEcoule from '../TempsEcoule'
import {useNavigate} from 'react-router-dom'
import DemandeInfos from '../DemandeInfos'

const HeaderDemandeTraitement = (props) => {
  const {demandeId, demandeClient, canCreate} = props
  const navigate = useNavigate()

  // Duplication de la demande pour le même client
  const handleDuplicate = () => {
    navigate('/demandes/liste', {
      state:
        {
          clientToDuplicate: {
            clientId: demandeClient?.client?.id,
            defaultValueContact: demandeClient?.contactedBy?.id,
            contentCommunication: demandeClient?.communication,
            radioValue: demandeClient?.email ? 'email' : demandeClient?.sms ? 'sms' : 'appel',
            contactedBy: demandeClient?.contactedBy,
            choicedDemandeSource: demandeClient?.demandeSource?.id,
            searchTerm:
                demandeClient?.client?.professionnel ? demandeClient?.client?.nomSociete : demandeClient?.client?.nom + ' ' + demandeClient?.client?.prenom,
            isDuplication: true
          }
        }
    })
  }

  return (
    <>
      <div className='p-5'>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='d-flex align-items-center gap-6'>
            <div className='d-flex flex-column gap-3'>
              {/*Bloc information demande*/}
              <DemandeInfos demandeId={demandeId} demandeClient={demandeClient} />
              <div>
                {canCreate && (
                  <div className='d-flex flex-row justify-content-end gap-5'>
                    <button
                      type='button'
                      className='btn btn-sm w-100 btn-primary'
                      onClick={() => handleDuplicate()}
                    >
                      Créer une nouvelle demande
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderDemandeTraitement
